import React, { useState } from 'react'
import { endOfMonth, startOfMonth, format } from 'date-fns'
import { useQuery } from '@tanstack/react-query'
import { FiEye, FiSearch } from 'react-icons/fi'

import Card from '../../../../components/Card'
import { api, authHeaders } from '../../../../services/api'
import Table from '../../../../components/Table'
import Spinner from '../../../../components/Spinner'
import { Button, Textbox } from '../../../../components/Form'
import { stringToDate } from '../../../../util/date'
import masks from '../../../../util/masks'
import { Container } from './styles'

const initialInicio = startOfMonth(new Date())
const initialFim = endOfMonth(new Date())

export default function () {
	const [inicio, setInicio] = useState(initialInicio)
	const [fim, setFim] = useState(initialFim)

	const { data: acessosPublicos, refetch: refetchAcessosPublicos } = useQuery({
		queryKey: ['get-acessos-publicos-pagina'],
		queryFn: async () => {
			const response = await api.get('acessos', {
				...authHeaders(),
				params: {
					inicio,
					fim,
					public_only: true,
					ignore_patterns: ['/login']
				}
			})

			return response
		}
	})

	const { data: acessosPrivados, refetch: refetchAcessosPrivados } = useQuery({
		queryKey: ['get-acessos-privados-pagina'],
		queryFn: async () => {
			const response = await api.get('acessos', {
				...authHeaders(),
				params: {
					inicio,
					fim,
					private_only: true
				}
			})

			return response
		}
	})

	if(!acessosPublicos || !acessosPrivados) {
		return (
			<Spinner />
		)
	}

	const acessosPublicosAgrupado = acessosPublicos.reduce((result, item) => {
		const quantidade = acessosPublicos.filter(a => a.rota === item.rota).length

		if(result.some(i => i.rota === item.rota)) {
			return result
		}

		return [
			...result,
			{
				rota: item.rota,
				quantidade
			}
		]
	}, [])

	console.log('acessosPrivados', acessosPrivados)

	const acessosPrivadosAgrupado = acessosPrivados.reduce((result, item) => {
		const quantidade = acessosPrivados.filter(a => a.rota === item.rota).length

		if(result.some(i => i.rota === item.rota)) {
			return result
		}

		return [
			...result,
			{
				rota: item.rota,
				quantidade,
				nome: 'teste'
			}
		]
	}, [])

	// console.log('acessosPrivadosAgrupado', acessosPrivadosAgrupado)

	return (
		<Container className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:my-12 leading-loose mt-8">
			<Card className="flex w-full gap-6 items-end">
				<Textbox 
					withoutForm
					label="Início"
					name="inicio"
					mask={masks.date}
					onChange={e => {
						setInicio(stringToDate(e.target.value) || initialInicio)
					}}
					value={format(inicio, 'dd/MM/yyyy')}
				/>

				<Textbox 
					withoutForm
					label="Fim"
					name="fim"
					mask={masks.date}
					onChange={e => {
						setFim(stringToDate(e.target.value) || initialFim)
					}}
					value={format(fim, 'dd/MM/yyyy')}
				/>

				<Button 
					onClick={() => {
						refetchAcessosPublicos()
						refetchAcessosPrivados()
					}}
				>
					Buscar
					<FiSearch size={16} />
				</Button>
			</Card>

			<div className="flex flex-col lg:flex-row">
				<Card className="flex flex-col w-full gap-6 flex-1">
					<h1 className="text-slate-800 mb-4">Acessos a páginas públicas</h1>

					<Table
						headers={[
							{ name: 'rota', value: 'Página' },
							{ name: 'quantidade', value: 'Quantidade' }
						]}
						data={acessosPublicosAgrupado}
						footers={[
							{
								text: 'TOTAL'
							},
							{
								text: acessosPublicos.length,
								align: 'center'
							}
						]}
					/>

					<details>
						<summary>
							<FiEye size={16} />
							Visão analítica
						</summary>
						<div>
							<Table
								headers={[
									{ name: 'rota', value: 'Página' },
									{ name: 'local', value: 'Local', centered: true },
									{ name: 'data_hora', value: 'Data e hora', centered: true }
								]}
								data={acessosPublicos.map(acesso => ({
									...acesso,
									data_hora: format(new Date(acesso.createdAt), 'dd/MM/yyyy HH:mm\'h\''),
									local: `${acesso.uf} - ${acesso.cidade}`
								}))}
								hideOffset={350}
								hideHeadersOffset={630}
								hideOnSmallHeaders={['local']}
							/>
						</div>
					</details>
				</Card>

				<Card className="flex flex-col w-full gap-6 flex-2">
					<h1 className="text-slate-800 mb-4">Acessos a páginas privadas</h1>

					<Table
						headers={[
							{ name: 'rota', value: 'Página' },
							{ name: 'quantidade', value: 'Quantidade' }
						]}
						data={acessosPrivadosAgrupado}
						footers={[
							{
								text: 'TOTAL'
							},
							{
								text: acessosPrivados.length,
								align: 'center'
							}
						]}
						tableStyle={{ marginTop: 0 }}
					/>

					<details>
						<summary>
							<FiEye size={16} />
							Visão analítica
						</summary>
						<div>
							<Table
								headers={[
									{ name: 'rota', value: 'Página' },
									{ name: 'local', value: 'Local', centered: true },
									{ name: 'nome', value: 'Nome', centered: true },
									{ name: 'email', value: 'E-mail', centered: true },
									{ name: 'data_hora', value: 'Data e hora', centered: true }
								]}
								data={acessosPrivados.map(acesso => ({
									...acesso,
									data_hora: format(new Date(acesso.createdAt), 'dd/MM/yyyy HH:mm\'h\''),
									local: `${acesso.uf} - ${acesso.cidade}`,
									nome: acesso.pessoa?.nome || '-',
									email: acesso.pessoa?.contato.find(c => c.tipo_contato_id === 6)?.contato || '-'
								}))}
								hideOffset={350}
								hideHeadersOffset={630}
								hideOnSmallHeaders={['local']}
							/>
						</div>
					</details>
				</Card>
			</div>
		</Container>
	)
}
